/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITyperampViewProps } from './typeramp';

export default (props: ITyperampViewProps) => {
    return (
        <div className='example'>
            <h1 className='section-title'>Type Ramp</h1>
            <hr />
            <h1>H1 - The Quick Brown Fox Jumps Over the Lazy Dog</h1>
            <p>
                <small>Akzidenz Grotesk Light 70px;</small>
            </p>
            <hr />
            <h2>H2 - The Quick Brown Fox Jumps Over the Lazy Dog</h2>
            <p>
                <small>Akzidenz Grotesk Light; 60px;</small>
            </p>
            <hr />
            <h3>H3 - The Quick Brown Fox Jumps Over the Lazy Dog</h3>
            <p>
                <small>Akzidenz Grotesk Semibold; 30px</small>
            </p>
            <hr />
            <h4>H4 - The Quick Brown Fox Jumps Over the Lazy Dog</h4>
            <p>
                <small>Akzidenz Grotesk Semibold; 18px</small>
            </p>
            <hr />
            <h5>H5 - The Quick Brown Fox Jumps Over the Lazy Dog</h5>
            <p>
                <small>Akzidenz Grotesk Semibold; 16px</small>
            </p>
            <hr />
            <p>Body Copy</p>
            <p>The Quick Brown Fox Jumps Over the Lazy Dog</p>
            <p>The Quick Brown Fox Jumps Over the Lazy Dog</p>
            <p>
                <small>Akzidenz Grotesk Regular; 16px</small>
            </p>
            <hr />
            <p>
                <small>Body Copy - Small</small>
            </p>
            <p>
                <small>The Quick Brown Fox Jumps Over the Lazy Dog</small>
            </p>
            <p>
                <small>The Quick Brown Fox Jumps Over the Lazy Dog</small>
            </p>
            <p>
                <small>Akzidenz Grotesk Regular; 14px</small>
            </p>
            <hr />

            <h1 className='section-title'>Line Height &amp; Spacing</h1>
            <h3>
                Headerlines and titles
                <br /> use ~120% line height. The approximation accounts for raised and dropped character spacing.
            </h3>
            <p>
                Paragraphs and other standard copy use ~130% line height. The approximation accounts for raised and dropped character
                spacing.
            </p>

            <h1 className='section-title'>Text Link Examples</h1>
            <p>
                Standard paragraph <a href='#'>text links</a> are TBD: plain and linked text should not be the same color without a
                distinqguishing color
            </p>
            <h4>
                Links in titles <a href='#'>are TBD:</a> as above.
            </h4>

            <h1 className='section-title'>Paragraph and Article Copy</h1>
            <div style={{ width: '475px' }}>
                <p>
                    Do you have questions about Microsoft Teams? Join the Ask Me Anything session for loads of answers. Get ready to ask any
                    questions you have on Thursday, March 21st. No matter which time zone you&apos;re in, you can log into the Ask Me
                    Anything session from 9am to 5pm your own local time.
                </p>
                <p>
                    Not sure what&apos;s gong on here? Check out our blog on how Teams will become your new confort zone when it eventually
                    replaces Skype for Business. Then, before you panic, go to the Teams AMA to find out everything you ever wanted to know
                    (and more).
                </p>
            </div>

            <h1 className='section-title'>Bulleted and Number Lists</h1>
            <p>Bulleted List</p>
            <ul>
                <li>I need an email account</li>
                <li>I need access to a printer</li>
                <li>I need to know how to import data into an application</li>
                <li>I need a firewall port opened/forwarded</li>
            </ul>
            <p>Numbered List</p>
            <ol>
                <li>I need an email account</li>
                <li>I need access to a printer</li>
                <li>I need to know how to import data into an application</li>
                <li>I need a firewall port opened/forwarded</li>
            </ol>
            <br />
            <br />
            <br />
        </div>
    );
};
